import { render, staticRenderFns } from "./AgCourseCard.vue?vue&type=template&id=265552cb&scoped=true&"
import script from "./AgCourseCard.vue?vue&type=script&lang=js&"
export * from "./AgCourseCard.vue?vue&type=script&lang=js&"
import style0 from "./AgCourseCard.vue?vue&type=style&index=0&id=265552cb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "265552cb",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VOverlay } from 'vuetify/lib/components/VOverlay';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCol,VIcon,VOverlay,VRow})
